import { render, staticRenderFns } from "./facets-group.vue?vue&type=template&id=28633d83&scoped=true&"
import script from "./facets-group.vue?vue&type=script&lang=js&"
export * from "./facets-group.vue?vue&type=script&lang=js&"
import style0 from "./facets-group.vue?vue&type=style&index=0&id=28633d83&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28633d83",
  null
  
)

export default component.exports